<template>
  <v-row>
    <v-container class='bg-white py-10'>
      <v-row class='flex flex-column align-center'>
        <v-col cols='7' class='flex flex-column align-center'>
          <v-img
            lazy-src="@/assets/images/404.png"
            max-height="300"
            max-width="100%"
            contain
            src="@/assets/images/404.png"
          />
        </v-col>
        <v-col cols='7' class='flex flex-column align-center mt-3'>
          <h2>Oops! Page Not Found</h2>
        </v-col>
        <v-col cols='7' class='flex flex-column align-center mt-2'>
          <p>Sorry, we can't find the page you're looking for.</p>
        </v-col>
        <v-col cols='7' class='flex flex-column align-center mt-3'>
          <v-btn
            tabindex="1"
            min-width='160'
            depressed
            link
            :to='{ name: "Dashboard" }'
            class="save-folder-btn save-btn px-2"
          >
            <v-img
              class='mr-2'
              lazy-src="@/assets/icons/svg/home.svg"
              max-height="16"
              max-width="16"
              contain
              color='white'
              src="@/assets/icons/svg/home.svg"
            />
            Back To Home
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
